'use client';

import Link from 'next/link';
import Image from '@/components/Image';
import { lazy, Suspense, useState } from 'react';

const LoginModal = lazy(() => import('@/components/LoginModal'));

type PublicSiteHeaderProps = {
  ctaLabel?: string;
  ctaHref?: string;
  ctaTarget?: '_self' | '_blank';
  compactLinkLabel?: string;
  compactLinkHref?: string;
};

export default function PublicSiteHeader({
  ctaLabel = 'Get Started',
  ctaHref,
  ctaTarget = '_self',
  compactLinkLabel,
  compactLinkHref,
}: PublicSiteHeaderProps) {
  const [loginModalVisible, setLoginModalVisible] = useState(false);

  return (
    <>
      <header
        className="sticky top-0 z-50 w-full bg-white"
        style={{ borderBottom: '1px solid #D7D9E0' }}
      >
        <div className="mx-auto flex h-[60px] max-w-[1440px] items-center justify-between px-3 md:px-8">
          <Link href="/" className="flex items-center gap-3">
            <Image
              src="/assets/landing-logo.png"
              alt="Pengi"
              width={36}
              height={36}
              optimizedWidth={72}
            />
            <span
              className="emphasize-text text-2xl font-bold"
              style={{ color: '#735648' }}
            >
              Pengi
            </span>
          </Link>

          <nav className="flex items-center gap-6">
            {compactLinkLabel && compactLinkHref ? (
              <Link
                href={compactLinkHref}
                className="display-text text-sm text-[#566070] transition hover:text-[#42C52D]"
              >
                {compactLinkLabel}
              </Link>
            ) : null}
            <Link
              href="/blog"
              className="display-text text-sm text-[#566070] transition hover:text-[#42C52D]"
            >
              Blog
            </Link>
            {ctaHref ? (
              <a
                href={ctaHref}
                target={ctaTarget}
                rel={ctaTarget === '_blank' ? 'noreferrer' : undefined}
                className="display-text-bold rounded-full bg-[#42C52D] px-5 py-2 text-base text-white transition hover:bg-[#38AC26]"
              >
                {ctaLabel}
              </a>
            ) : (
              <button
                type="button"
                onClick={() => setLoginModalVisible(true)}
                className="display-text-bold rounded-full bg-[#42C52D] px-5 py-2 text-base text-white transition hover:bg-[#38AC26]"
              >
                {ctaLabel}
              </button>
            )}
          </nav>
        </div>
      </header>

      {!ctaHref ? (
        <Suspense fallback={null}>
          <LoginModal
            visible={loginModalVisible}
            onClose={() => setLoginModalVisible(false)}
          />
        </Suspense>
      ) : null}
    </>
  );
}
